import React, { useEffect, createElement } from 'react';
import { Play } from 'lucide-react';
const HOP_LINK = 'https://d0d38frttj2fs0yhx2url2skbi.hop.clickbank.net';
const ORANGE = '#FF6B35';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
const handleCtaClick = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout');
  }
};
export function App() {
  useEffect(() => {
    // Inject Facebook Pixel Base Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '666521186552257');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=666521186552257&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    return () => {
      if (script.parentNode) document.head.removeChild(script);
      if (noscript.parentNode) document.head.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen w-full bg-white text-gray-900" data-id="element-0">
      <article className="mx-auto max-w-[700px] px-5 sm:px-6 py-8 sm:py-12" data-id="element-1">
        {/* META */}
        <div className="flex items-center gap-3 text-xs text-gray-500 mb-5" data-id="element-2">
          <span className="font-semibold uppercase tracking-wider" style={{
          color: ORANGE
        }} data-id="element-3">
            Health News
          </span>
          <span className="text-gray-300" data-id="element-4">|</span>
          <span data-id="element-5">5 min read</span>
        </div>

        {/* HEADLINE */}
        <h1 className="font-article text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.2] text-gray-900 mb-6" data-id="element-6">
          Doctors Are Stunned: This Simple Morning Habit Is Helping Thousands of
          Americans Finally Get Rid of Joint Pain
        </h1>

        {/* BYLINE */}
        <div className="flex items-center gap-3 pb-6 mb-8 border-b border-gray-100" data-id="element-7">
          <div className="text-sm" data-id="element-8">
            <p className="font-medium text-gray-900" data-id="element-9">Health Desk Editorial</p>
            <p className="text-gray-500 text-xs" data-id="element-10">Updated this week</p>
          </div>
        </div>

        {/* STORY */}
        <div className="font-article text-lg sm:text-[19px] leading-[1.7] text-gray-800 space-y-5 mb-10" data-id="element-11">
          <p data-id="element-12">
            For more than 14 years, <strong data-id="element-13">Martha, 67, from Ohio</strong>, woke
            up every morning to the same sharp, grinding ache in her knees and
            hips. Some days she could barely make it down the stairs without
            holding the railing with both hands. "I felt like my body had aged
            30 years overnight," she told us.
          </p>

          <p data-id="element-14">
            She had tried it all — prescription anti-inflammatories, expensive
            supplements from the pharmacy, physical therapy twice a week, even
            cortisone shots that worked for a few weeks and then stopped
            helping. Her doctors kept telling her the same thing:{' '}
            <em data-id="element-15">"At your age, this is just part of life."</em> Martha refused to
            believe that.
          </p>

          <p data-id="element-16">
            Then, one quiet morning last spring, something unexpected happened.
            While visiting her sister in a small town outside Asheville, Martha
            was handed a glass of warm water mixed with what looked like a
            simple amber-colored powder. Her sister had read about it online and
            swore it had given her own joints a "second chance."
          </p>

          <p data-id="element-17">
            Martha didn't expect much. But within a few weeks of starting this
            strange little morning ritual, the stiffness in her knees started to
            fade. The sharp pain in her hips dulled. She began taking walks
            again — first around the block, then through the park. Her family
            couldn't believe the change. Even her doctor was puzzled.
          </p>

          <p className="text-gray-900 font-semibold" data-id="element-18">
            What Martha discovered that morning is now being talked about by
            thousands of Americans over 50 — and most people have never heard of
            it.
          </p>
        </div>

        {/* VIDEO PLACEHOLDER */}
        <div className="mb-4" data-id="element-19">
          <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="group relative block w-full aspect-video rounded-lg overflow-hidden bg-gray-900 shadow-lg" aria-label="Watch the video" data-id="element-20">
            {/* Subtle gradient backdrop to feel like a video thumbnail */}
            <div className="absolute inset-0 bg-gradient-to-br from-gray-800 via-gray-900 to-black" data-id="element-21" />
            <div className="absolute inset-0 opacity-30" style={{
            backgroundImage: 'radial-gradient(circle at 30% 40%, rgba(255,107,53,0.25), transparent 60%)'
          }} data-id="element-22" />

            {/* Play button */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-23">
              <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full flex items-center justify-center shadow-2xl transition-transform duration-200 group-hover:scale-110" style={{
              backgroundColor: ORANGE
            }} data-id="element-24">
                <Play size={36} className="text-white ml-1.5" fill="white" data-id="element-25" />
              </div>
            </div>

            {/* Bottom label inside the thumbnail */}
            <div className="absolute bottom-0 left-0 right-0 px-4 py-3 bg-gradient-to-t from-black/70 to-transparent" data-id="element-26">
              <p className="text-white text-sm font-medium" data-id="element-27">
                ▶ Click to play video
              </p>
            </div>
          </a>

          <p className="text-center text-sm text-gray-600 mt-3 font-medium" data-id="element-28">
            ⚠️ Watch this short video before it gets taken down
          </p>
        </div>

        {/* CTA */}
        <div className="mt-8 mb-6" data-id="element-29">
          <a href={HOP_LINK} target="_blank" rel="noopener noreferrer" onClick={handleCtaClick} className="block w-full text-center py-4 sm:py-5 px-6 rounded-md text-white font-bold text-lg sm:text-xl transition-all duration-200 hover:brightness-105 shadow-md hover:shadow-lg" style={{
          backgroundColor: ORANGE
        }} data-id="element-30">
            Yes! Show Me The Solution →
          </a>
        </div>

        {/* TINY DISCLAIMER */}
        <div className="mt-12 pt-6 border-t border-gray-100" data-id="element-31">
          <p className="text-[11px] leading-relaxed text-gray-400 text-center" data-id="element-32">
            The information in this article is for educational purposes only and
            has not been evaluated by the FDA. This product is not intended to
            diagnose, treat, cure, or prevent any disease. Results may vary.
            Individual testimonials are not guaranteed.
          </p>
        </div>
      </article>
    </div>;
}